import { barcodeLabelContentProps, barcodeLabelProps } from './properties'

export const setPreferenceInformation = (state, payload) => {

    state.props = payload
    if(payload.work_order_delivery_label === null || payload.work_order_delivery_label.length === 0) {
        state.props.work_order_delivery_label = JSON.parse(JSON.stringify(barcodeLabelProps))
    }
    if(payload.inventory_sale_ready_label === null || payload.inventory_sale_ready_label.length === 0) {
        state.props.inventory_sale_ready_label = JSON.parse(JSON.stringify(barcodeLabelProps))
    }
    if(payload.work_order_delivery_label === null || payload.work_order_delivery_label.length === 0) {
        state.props.work_order_delivery_label = JSON.parse(JSON.stringify(barcodeLabelProps))
    }
    if(payload.production_item_label === null || payload.production_item_label.length === 0) {
        state.props.production_item_label = JSON.parse(JSON.stringify(barcodeLabelProps))
    }
    if(payload.inventory_sale_label === null || payload.inventory_sale_label.length === 0) {
        state.props.inventory_sale_label = JSON.parse(JSON.stringify(barcodeLabelProps))
    }
    if(payload.inventory_stock_label === null || payload.inventory_stock_label.length === 0) {
        state.props.inventory_stock_label = JSON.parse(JSON.stringify(barcodeLabelProps))
    }
    if(payload.work_order_washable_label === null || payload.work_order_washable_label.length === 0) {
        state.props.work_order_washable_label = JSON.parse(JSON.stringify(barcodeLabelProps))
    }
    if(payload.work_order_dryclean_label === null || payload.work_order_dryclean_label.length === 0) {
        state.props.work_order_dryclean_label = JSON.parse(JSON.stringify(barcodeLabelProps))
    }
    
    /*CHECK CODE TYPE*/
    if(state.props.work_order_delivery_label.label_size.code_type === undefined) {
        state.props.work_order_delivery_label.label_size.code_type = 0
    }
    if(state.props.inventory_sale_ready_label.label_size.code_type === undefined) {
        state.props.inventory_sale_ready_label.label_size.code_type = 0
    }
    if(state.props.work_order_delivery_label.label_size.code_type === undefined) {
        state.props.work_order_delivery_label.label_size.code_type = 0
    }
    if(state.props.production_item_label.label_size.code_type === undefined) {
        state.props.production_item_label.label_size.code_type = 0
    }
    if(state.props.inventory_sale_label.label_size.code_type === undefined) {
        state.props.inventory_sale_label.label_size.code_type = 0
    }
    if(state.props.inventory_stock_label.label_size.code_type === undefined) {
        state.props.inventory_stock_label.label_size.code_type = 0
    }
    if(state.props.work_order_dryclean_label.label_size.code_type === undefined) {
        state.props.work_order_dryclean_label.label_size.code_type = 0
    }
    if(state.props.work_order_washable_label.label_size.code_type === undefined) {
        state.props.work_order_washable_label.label_size.code_type = 0
    }
    /**/

    /*CHECK MARGINS*/
    if(state.props.work_order_delivery_label.label_size.left_margin === undefined) {
        state.props.work_order_delivery_label.label_size.left_margin = 0
        state.props.work_order_delivery_label.label_size.top_margin = 0
    }
    if(state.props.inventory_sale_ready_label.label_size.left_margin === undefined) {
        state.props.inventory_sale_ready_label.label_size.left_margin = 0
        state.props.inventory_sale_ready_label.label_size.top_margin = 0
    }
    if(state.props.work_order_delivery_label.label_size.left_margin === undefined) {
        state.props.work_order_delivery_label.label_size.left_margin = 0
        state.props.work_order_delivery_label.label_size.top_margin = 0
    }
    if(state.props.production_item_label.label_size.left_margin === undefined) {
        state.props.production_item_label.label_size.left_margin = 0
        state.props.production_item_label.label_size.top_margin = 0
    }
    if(state.props.inventory_sale_label.label_size.left_margin === undefined) {
        state.props.inventory_sale_label.label_size.left_margin = 0
        state.props.inventory_sale_label.label_size.top_margin = 0
    }
    if(state.props.inventory_stock_label.label_size.left_margin === undefined) {
        state.props.inventory_stock_label.label_size.left_margin = 0
        state.props.inventory_stock_label.label_size.top_margin = 0
    }
    /**/

    /*CHECK FONT SIZE*/
    if(state.props.work_order_delivery_label.label_size.font_size === undefined) {
        state.props.work_order_delivery_label.label_size.font_size = 12
    }
    if(state.props.inventory_sale_ready_label.label_size.font_size === undefined) {
        state.props.inventory_sale_ready_label.label_size.font_size = 12
    }
    if(state.props.work_order_delivery_label.label_size.font_size === undefined) {
        state.props.work_order_delivery_label.label_size.font_size = 12
    }
    if(state.props.production_item_label.label_size.font_size === undefined) {
        state.props.production_item_label.label_size.font_size = 12
    }
    if(state.props.inventory_sale_label.label_size.font_size === undefined) {
        state.props.inventory_sale_label.label_size.font_size = 12
    }
    if(state.props.inventory_stock_label.label_size.font_size === undefined) {
        state.props.inventory_stock_label.label_size.font_size = 12
    }
    /**/

}

export const setBarcodeLabelPreview = (state, payload) => {
    
    let labelArraySource = null
    if(payload.type === "retail") {
        labelArraySource = state.props.inventory_sale_label
    } else if(payload.type === 'stock') {
        labelArraySource = state.props.inventory_stock_label
    } else if(payload.type === 'workorder') {
        labelArraySource = state.props.work_order_label
    } else if(payload.type === 'workorder_delivery_tag') {
        labelArraySource = state.props.work_order_delivery_label
    } else if(payload.type === 'ready_item') {
        labelArraySource = state.props.inventory_sale_ready_label
    } else if(payload.type === 'workorder_washable') {
        labelArraySource = state.props.work_order_washable_label
    } else if(payload.type === 'workorder_dryclean') {
        labelArraySource = state.props.work_order_dryclean_label
    }    
    
    let returnData = ""
    returnData = "^XA"
    labelArraySource.label_contents.forEach(element => {

        returnData = returnData+"^FO"+element.x_axis+","+element.y_axis+(element.content_type === 0 ? "^A"+(element.font_bold ? "0, 40" : "1, 30")+"^FD"+element.content : "^BQR,2,"+element.qr_height+",H,2^FDQA,"+element.content)
        
        returnData = returnData+"^FS"
    })
    returnData = returnData+"^XZ"

    labelArraySource.preview = "https://api.labelary.com/v1/printers/8dpmm/labels/"+labelArraySource.label_size.width+"x"+labelArraySource.label_size.height+"/0/"+returnData
    
}

export const addNewBarcodeLabelRow = (state, payload) => {
    
    let key = 0

    let labelArraySource = null
    if(payload.type === "retail") {
        labelArraySource = state.props.inventory_sale_label
    } else if(payload.type === 'stock') {
        labelArraySource = state.props.inventory_stock_label
    } else if(payload.type === 'workorder') {
        labelArraySource = state.props.work_order_label
    } else if(payload.type === 'ready_item') {
        labelArraySource = state.props.inventory_sale_ready_label
    } else if(payload.type === 'workorder_delivery_tag') {
        labelArraySource = state.props.work_order_delivery_label
    } else if(payload.type === 'workorder_washable') {
        labelArraySource = state.props.work_order_washable_label
    } else if(payload.type === 'workorder_dryclean') {
        labelArraySource = state.props.work_order_dryclean_label
    }    
    
    labelArraySource.label_contents.push(JSON.parse(JSON.stringify(barcodeLabelContentProps)))

    labelArraySource.label_contents.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeBarcodeLabelRow = (state, payload) => {

    let key = 0

    let labelArraySource = null
    if(payload.type === "retail") {
        labelArraySource = state.props.inventory_sale_label
    } else if(payload.type === 'stock') {
        labelArraySource = state.props.inventory_stock_label
    } else if(payload.type === 'workorder') {
        labelArraySource = state.props.work_order_label
    } else if(payload.type === 'ready_item') {
        labelArraySource = state.props.inventory_sale_ready_label
    } else if(payload.type === 'workorder_delivery_tag') {
        labelArraySource = state.props.work_order_delivery_label
    } else if(payload.type === 'workorder_washable') {
        labelArraySource = state.props.work_order_washable_label
    } else if(payload.type === 'workorder_dryclean') {
        labelArraySource = state.props.work_order_dryclean_label
    }

    labelArraySource.label_contents.splice(payload.key, 1)

    labelArraySource.label_contents.forEach(element => {
        element.key = key
        key ++
    })

}


// WEBPACK FOOTER //
// ./src/store/modules/preferences/mutations.js